import { useState } from 'react';
import { DateTime } from 'luxon';
import { DATE_FORMAT, TIME_FORMAT } from './constants';

let autoId = 0;
export function useAutoId(namespace = '') {
  const [id] = useState(() => `auto-id-${namespace}${autoId++}`);
  return id;
}

export function toEventObject(name, value) {
  return { target: { name, value } };
}

export function getDateTimeFromDateString(
  value,
  {
    format = DATE_FORMAT,
    dateLikes = [
      /^(\d{4})[^\d](\d{2}|\d{1})[^\d](\d{2}|\d{1})$/,
      /^(\d{4})(\d{2})(\d{2})$/,
    ],
  } = {},
) {
  const dateTime = DateTime.fromFormat(value, format);
  if (dateTime.isValid) return dateTime;

  for (const dateLike of dateLikes) {
    if (!dateLike.test(value)) continue;

    const [, year, month, day] = dateLike.exec(value);
    const dateTime = DateTime.local(Number(year), Number(month), Number(day));
    if (dateTime.isValid) return dateTime;
  }

  return DateTime.invalid(`value: ${value}`);
}

export function getDateTimeFromTimeString(
  value,
  {
    format = TIME_FORMAT,
    timeLikes = [/^(\d{2}|\d{1})[^\d](\d{2}|\d{1})$/, /^(\d{2})(\d{2})$/],
  } = {},
) {
  const dateTime = DateTime.fromFormat(value, format);
  if (dateTime.isValid) return dateTime;

  for (const timeLike of timeLikes) {
    if (!timeLike.test(value)) continue;

    const [, hour, minute] = timeLike.exec(value);
    const dateTime = DateTime.local(1970, 1, 1, Number(hour), Number(minute));
    if (dateTime.isValid) return dateTime;
  }

  return DateTime.invalid(`value: ${value}`);
}
